<script lang="ts">
	import { notificationsToShowForOngoingCompetitions } from '$lib/home/tradingRewards/store';
	import CompetitionNotification from './CompetitionNotification.svelte';
	import PopNotification from './PopNotification.svelte';
	import { notifications, closedWrapped2023 } from './store';
</script>

{#if ($notifications && Object.keys($notifications).length > 0) || $notificationsToShowForOngoingCompetitions.length > 0 || !$closedWrapped2023}
	<div
		class="flex-col gap-6 fixed sm:right-4 bottom-12 z-50 sm:w-1/3 2xl:w-[500px] w-full px-2 sm:px-0"
	>
		{#each $notificationsToShowForOngoingCompetitions as oc}
			<CompetitionNotification competitionId={oc} />
		{/each}
		{#each Object.keys($notifications) as id}
			<PopNotification notifId={id} notif={$notifications[id]} />
		{/each}
	</div>
{/if}
